import { render, staticRenderFns } from "./goaway.vue?vue&type=template&id=3fa282de&scoped=true"
import script from "./goaway.vue?vue&type=script&lang=js"
export * from "./goaway.vue?vue&type=script&lang=js"
import style0 from "./goaway.vue?vue&type=style&index=0&id=3fa282de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa282de",
  null
  
)

export default component.exports